import Cookies from 'js-cookie';
import { getClubSignup, isCustomerSignedIn } from './c7-api';
import { COOKIE_NAME_CLUB_SIGNUP_ID } from './c7-api-constants';
export const CLUB_SIGNUP_PAGE = /^\/club\/(?:[A-Za-z0-9\-]+)\/?$/i;
export const QUERY_NAME_CLUB_SIGNUP_ID = 'clubSignupId';

const C7ClubSignupCookie = {
  init() {
    if (!this.isClubSignupPage()) return;

    const clubSignupId = this.getQueryParamValue(QUERY_NAME_CLUB_SIGNUP_ID);

    // Skip setting `clubSignupId` cookie or fetching API if the same clubSignupId value already exists in cookies
    if (clubSignupId === Cookies.get(COOKIE_NAME_CLUB_SIGNUP_ID)) {
      return;
    }

    getClubSignup(clubSignupId)
      .then((clubSignup) => {
        if (!this.isValidClubSignup(clubSignup)) throw new Error('invalid clubSignup');

        let customerId = clubSignup.customerId || clubSignup.customer?.id;

        if (customerId) {
          return isCustomerSignedIn(customerId).then((isSignedIn) => {
            if (!isSignedIn) throw new Error('unauthorized customer');
            return clubSignup;
          });
        }

        return clubSignup;
      })
      .then((clubSignup) => {
        this.setCookie(clubSignup.id);
      })
      .catch(console.log);
  },

  setCookie(clubSignupId) {
    Cookies.set(COOKIE_NAME_CLUB_SIGNUP_ID, clubSignupId, { expires: 365});
  },

  isValidClubSignup(clubSignup) {
    if (!clubSignup || !clubSignup?.id) {
      return false;
    }

    if (clubSignup.status !== 'Pending') {
      return false;
    }

    if (clubSignup.acquisitionChannel !== 'Web') {
      return false;
    }

    return true;
  },

  isClubSignupPage() {
    const { pathname } = new URL(window.location);
    return CLUB_SIGNUP_PAGE.test(pathname);
  },

  getQueryParamValue(param) {
    return new URL(window.location).searchParams.get(param);
  },
};

export default C7ClubSignupCookie;
